import React from "react";
import { Elements, useYooptaEditor } from "@yoopta/editor";
import { limitSizes } from "../utils/limitSizes.js";
import { UploadAsset } from "../../../../files/Upload.js";
import { useGameIdFromRoute } from "../../../../games/WithGameIdFromRoute.js";

const Placeholder = ({ attributes, children, blockId }) => {
  const editor = useYooptaEditor();
  const gameId = useGameIdFromRoute();

  /**
   * @param {string} url
   */
  const onUploadComplete = async (url) => {
    console.log({ url });

    try {
      const defaultImageProps = editor.plugins.Image.elements.image.props;
      const sizes = defaultImageProps.sizes;
      const maxSizes = editor.plugins.Image.options.maxSizes;
      const limitedSizes = limitSizes(sizes, {
        width: maxSizes.maxWidth,
        height: maxSizes.maxHeight,
      });

      Elements.updateElement(editor, blockId, {
        type: "image",
        props: {
          src: url,
          sizes: limitedSizes,
          bgColor: defaultImageProps.bgColor,
          fit: defaultImageProps.fit || "fill",
        },
      });
    } catch (error) {
    } finally {
    }
  };

  return (
    <div
      className="yoo-image-w-full yoo-image-user-select-none yoo-image-m-[20px_0_10px] yoo-image-relative yoo-image-flex"
      {...attributes}
      contentEditable={false}
    >
      <div
        className={`yoopta-button yoo-image-flex yoo-image-items-center yoo-image-text-left yoo-image-w-full yoo-image-overflow-hidden yoo-image-rounded-[3px] yoo-image-text-[14px] yoo-image-text-[rgba(55,53,47,0.65)] yoo-image-relative yoo-image-cursor-pointer yoo-image-border-none yoo-image-transition-[background-color_100ms_ease-in]`}
      >
        <div style={{ flex: 1 }}>
          <UploadAsset gameId={gameId} onUploadComplete={onUploadComplete} />
        </div>
      </div>
      {children}
    </div>
  );
};

export { Placeholder };
